module.exports = __webpack_public_path__ + "media/images/icon__community@2x-680c47dad3e7f175855c4660d573dbd4.png";